import React, { useEffect, useState } from "react";
import "./AllBlogsContainer.css";

// servics
import { AllBlogs } from "../../Service/data";
import { searchCatego } from "../../Service/data";
import { searchBlogs } from "../../Service/data";
// Images
import LoadSVG from '../../../assets/imags/ContentLoading.svg';
import NoResult from '../../../assets/imags/NoResult.svg';
//
import BeatLoader from "react-spinners/BeatLoader";


export const AllBlogsContainer = () =>{

    const LoadingBlog = <BeatLoader color={"#007bff"} loading={true} size={13} margin={5} />;

    const loadingJSX =  <div className="LoadingBlogContainer d-flex flex-column justify-content-center align-items-center">
                            <img className="Ladsvg"  src={LoadSVG} />
                            {LoadingBlog}
                            <p className="LoadingLable"> Loading </p>
    </div>


    const [ blogs , setAllBlogs ] = useState([]);
    const [ Loading , setLoading ] = useState(loadingJSX);
    const [ noResult , setNoResult ] = useState(false);



    const queryString = window.location.search;
    const searchValues = queryString.replace('?search=', '');

    const queryString2 = window.location.search;
    const CategoriesValue = queryString2.replace('?c=', '');





    useEffect(()=>{
        if (searchValues.length <= 0 && CategoriesValue.length <= 0 || CategoriesValue == "all") {
            AllBlogs().then((data)=>{
                setAllBlogs(data);
                if (data.length <= 0) {
                    setNoResult(true);
                }else{
                    setNoResult(false);
                }
            })
        }else{
            if (searchValues.length > 0) {
                searchBlogs(searchValues).then((res)=>{
                    setAllBlogs(res);
                    if (res.length <= 0) {
                        setNoResult(true);
                    }else{
                        setNoResult(false);
                    }
                })
            }else if(CategoriesValue.length > 0) {
                searchCatego(CategoriesValue).then((res)=>{
                    setAllBlogs(res);
                    if (res.length <= 0) {
                        setNoResult(true);
                    }else{
                        setNoResult(false);
                    }
                })
            }else{
                AllBlogs().then((data)=>{
                    setAllBlogs(data);
                    if (data.length <= 0) {
                        setNoResult(true);
                    }else{
                        setNoResult(false);
                    }
                })
            }
        }
    },[]);


    const hideLoading = () => {

        if (blogs.length > 0){
            let LoadingContent = document.getElementById("LoadingContent");
            LoadingContent.style.display = "none";
        }
        

        if (noResult) {
            setTimeout(() => {
                let LoadingContent = document.getElementById("LoadingContent");
                LoadingContent.style.display = "none";
                setTimeout(() => {
                    let noResult = document.getElementById("noResult");
                    noResult.style.display = "block";
                }, 0);
            }, 1000);
        }else{
            console.log(2);
            setTimeout(() => {
                let noResult = document.getElementById("noResult");
                noResult.style.display = "none";
            }, 0);
        }
    }

    useEffect(()=>{
        hideLoading();
    });

    


    return(
        <div className="AllBlogsContainerBody ">

            <div className="BlogMainInfoDiv d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center BreadcrumbLabe" id="marginbot">
                    <span>Blogs</span> <i class="fas fa-angle-right BreadcrumbIcon"></i> <span>All</span>
                </div>
                <i class="fas fa-sliders-h settIcon"></i>
            </div>

            <div id="noResult">
                <div className="LoadingBlogContainer d-flex flex-column justify-content-center align-items-center">
                    <img className="Ladsvg" src={NoResult} />
                    <p className="LoadingLable"> Leider Konnten wir keinen Treffer für <span className="strongFont">"{searchValues}"</span> finden. </p>
                </div>
            </div>

            <div id="LoadingContent" >
                { Loading }
            </div>

            <div className="gridd">

                { blogs.map( Blog => 
                    <div className="BlogCardB">
                        <a href={"/Blog?id=" + Blog.id}>
                            <div className="BlogCardImageContainerB">
                                <img className="BlogCardImage" src={Blog.BlogImage} alt="Blog Image" />
                            </div>
                        </a>
                        <div className="BlogCardTitleContainerB">
                                <p className="BlogCardTitleB"> <a href={"/Blog?id=" + Blog.id}> { Blog.BlogTitle } </a></p>
                        </div>

                        <div className="BlogCardInfoDatumB">
                            { Blog.date + " " }  { Blog.author } <i className="fas fa-comment-dots"></i> { Blog.CommentsNumber }
                        </div>
                    
                    </div> 
                )}
            </div>
        </div>
    );
}